<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <list-page
        :columns="columns"
        :headers="headers"
        :popupComponent="popupComponent"
        title="Reseller Payment List"
        icon="mdi-bank"
        sort="created_at"
        :basic-data="basicData"
        :descending="true"
        addButtonText="Reseller"
        stateendpoint="reseller.resellerPayments"
        :actions="actions"
        :action-buttons="actionButton"
    />
  </div>
</template>
<script>
import ListPage from "../components/ListPage";
import ResellerPaymentPopup from "../components/popups/ResellerPaymentPopup";

export default {
  name: 'Resellers',
  metaInfo: {
    title: 'zetrank.com',
    titleTemplate: 'Admin Dashboard - Resellers | %s',
    meta: [
      { name: 'robots', content: 'noindex' },
      { name: 'googlebot', content: 'noindex' }
    ]
  },
  components: {ListPage, ResellerPaymentPopup},
  data() {
    return {
      headers: [
        {
          text: 'Ref Code',
          value: 'refcode'
        },
        {
          text: 'Email',
          value: 'email'
        },
        {
          text: 'Price',
          value: 'price'
        },
        {
          text: 'Payment Status',
          value: 'paymentStatus'
        },
        {
          text: 'Created Date',
          value: 'created_at'
        },
        {
          text: 'Ref. Link',
          value: 'refLink',
          align: 'right',
          sortable: false
        },
        {
          text: 'Template',
          value: 'template',
          align: 'right',
          sortable: false
        },
        {
          text: '', value: 'actions', sortable: false
        }
      ],
      columns: [
        {value: 'refcode'},
        {value: 'email'},
        {value: 'price'},
        {value: 'created_at'},
        {value: 'paymentStatus'},
        {value: 'action'}
      ],
      actions: {
        load: 'loadResellerPayments',
        create: 'storeResellerPayment',
        update: 'updateResellerPayment',
        remove: 'destroyResellerPayment'
      },
      basicData: {
        price: 0,
        sites: []
      },
      actionButton: [
        {
          category: 'link',
          icon: 'mdi-eye',
          color: '',
          text: 'View Live Link',
          clickHandler: 'linkHandler'
        },
      ]
    }
  },
  computed: {
    popupComponent() {
      return ResellerPaymentPopup;
    }
  }
}
</script>
